import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../utils/Adapters';
import { CMSAPI_INDEX } from '../../../utils/CmsAPI';
import config from '../../../config';

const reset = createAction(types.ACTION_RESET);
const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const resetStoryItems = () => {
  return (dispatch) => {
    dispatch(reset());
  };
};

const fetchData = (categoryVal, max, query) => {
  const storyQueryObj = {};
  storyQueryObj.prefixPath = config.lscsPath;
  storyQueryObj.projectName = 'designinspireV2';
  storyQueryObj.max = max ? max : 300;
  storyQueryObj.sortBy = '+contentPublishDate';
  storyQueryObj.enableDate = false;
  storyQueryObj.q = `(displayStatus:online)%20AND%20(TeamSite/Templating/DCR/Type:=%22Designer Story/Story Items%22)`  + query;
  const url = CMSAPI_INDEX(storyQueryObj);
  return axiosAdapter({
    url,
  });
};

const massageData = (response) => {
  const responseData = response.data;
  const data = responseData.result.assets;
  const languages = ['en', 'tc', 'sc'];
  const storyCollection = { en: [], tc: [], sc: [] };
  if (!data) {
    throw new Error('no data');
  }

  languages.map((lang) => {
    if (
      responseData.included > 0 &&
      Array.isArray(responseData.result.assets) &&
      responseData.result.assets.length > 0
    ) {
      responseData.result.assets.map((story) => {
        const reference = story['content']['content'];
        if (reference[lang]['coreInfo']['storyTitle']) {
          const item = {};
          // massage item
          item.storyID = story['metadata']['storyID'];
          item.mainCategory = story['metadata']['mainCategory'];
          item.mainCategory_name = story['metadata'][`mainCategory_${lang}`];
          item.title = reference[lang]['coreInfo']['storyTitle'];
          item.company = reference[lang]['coreInfo']['companyName'];
          item.cover = reference['coverImage_container']['cover_upload'];
          item.type = reference[lang]['coreInfo']['storyType'];
          switch (item.type) {
            case 'storyPage':
              const pageURL = reference[lang]['page_container']['pageURL'];
              item.url = `${config.routePathTo}/${lang}/story/details/${pageURL}`;
              item.abstract = reference[lang]['page_container']['storyAbstract'];
              break;
            case 'videoOnly':
              item.url = reference[lang]['video_container']['videoURL'];
              break;
            case 'fileDownload':
              item.url = reference[lang]['file_container']['filePath'];
              break;
          }

          storyCollection[lang].push(item);
        }
      });
    }
  });

  return storyCollection;
};

const getHomepageStoryItems = (categoryVal, max, query) => {
  return (dispatch) => {
    dispatch(requestFetch({ categoryVal }, max, query));
    return fetchData(categoryVal, max, query)
      .then((response) => massageData(response))
      .then((data) => dispatch(receiveSuccess(data)))
      .catch((error) => {
        const message = messageError(error);
        dispatch(receiveError(message));
      });
  };
};

const getStoryItemByFilename = (filename) => {
  return fetchItemData(filename)
    .then((response) => massageData(response))
    .catch((error) => {
      throw error;
    });
};

const fetchItemData = (filename) => {
  const storyQueryObj = {};
  storyQueryObj.prefixPath = config.lscsPath;
  storyQueryObj.projectName = 'designinspireV2';
  storyQueryObj.max = 1;
  storyQueryObj.enableDate = false;
  storyQueryObj.q = `(displayStatus:online)%20AND%20(TeamSite/Templating/DCR/Type:=%22Designer Story/Story Items%22) AND (Path:/${filename}.xml)`;
  const url = CMSAPI_INDEX(storyQueryObj);
  return axiosAdapter({
    url,
  });
};

export { getHomepageStoryItems, getStoryItemByFilename };
